export default __webpack_public_path__ + "static/media/profile-privacy-16px.08ddb5a9.svg";